import { collectUtmParams } from '@/services/utm';

export type StationFinderEvent =
  | 'sf_page_view'
  | 'sf_location_submitted'
  | 'sf_notify_requested'
  | 'sf_geolocation_used'
  | 'sf_band_shown'
  | 'sf_geocode_degraded'
  | 'sf_map_unavailable';

/* GTM forwards a dataLayer entry as URL-encoded form data, so a value has to survive
   that trip. Objects, arrays, functions and undefined do not, which is why the payload
   is flat and its values are scalars. */
export type AnalyticsValue = string | number | boolean | null;

export type AnalyticsPayload = Record<string, AnalyticsValue>;

declare global {
  interface Window {
    dataLayer?: AnalyticsPayload[];
  }
}

/* Sink is Google Analytics via the GTM dataLayer, same as lp-conquista. Without
   these events a drop in conversion caused by this page would be invisible.

   Every event carries the campaign parameters of the URL that opened the page. GA4
   attributes utm_source and utm_medium on its own, but not the free parameters a
   campaign invents, and those are the ones that say which bot message or which post
   sent the lead here. */
export const track = (event: StationFinderEvent, payload: AnalyticsPayload = {}): void => {
  try {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    window.dataLayer.push({
      event,
      lp: 'station-finder',
      ...collectUtmParams(window.location.search),
      ...payload,
    });
  } catch {
    // Analytics must never block the flow.
  }
};
